module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "manara-school-building.2bee3ae5.webp" + "?" + Date.now();